<template>
  <div>
    <div v-if="showMobileSearch" class="plc-searchMobile">
      <input
        ref="search-mobile"
        type="search"
        class="plc-searchMobile__input"
        :value="modelValue"
        :placeholder="placeholder"
        @input="$emit('update:modelValue', $event.target.value)"
        @keyup.enter="handleSearch"
      />
      <button class="plc-searchMobile__btn" @click="handleSearch">
        <gl-svg-icon name="search" />
      </button>
    </div>
    <button
      class="toggleBtn"
      :class="{ 'toggleBtn--open': showMobileSearch }"
      @click="toggleSearch"
    >
      <gl-svg-icon :name="showMobileSearch ? 'close' : 'search'" />
    </button>
  </div>
</template>

<script>
import GlSvgIcon from '@gl/GlSvgIcon'

export default {
  name: 'HeaderSearchMobile',
  components: { GlSvgIcon },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      showMobileSearch: false,
    }
  },
  methods: {
    handleSearch() {
      this.$emit('change')
    },
    toggleSearch() {
      this.$emit('update:modelValue', '')
      this.showMobileSearch = !this.showMobileSearch
      if (this.showMobileSearch) this.$nextTick(() => this.$refs['search-mobile'].focus())
    },
  },
}
</script>

<style lang="scss" scoped>
.plc-searchMobile {
  background-color: $color-header;
  bottom: 0;
  display: flex;
  left: 0;
  position: absolute;
  right: 50px;
  top: 0;

  &__input {
    @include placeholder(rgba(255, 255, 255, 0.37));

    background: transparent;
    border: 0;
    color: #fff;
    flex-grow: 1;
    font-family: $font-family;
    outline: none;
    padding-left: 16px;
    text-overflow: ellipsis;

    &::-webkit-search-cancel-button {
      /* stylelint-disable-next-line */
      -webkit-appearance: none;
    }
  }

  &__btn {
    align-items: center;
    background-color: transparent;
    border: 0;
    color: #fff;
    cursor: pointer;
    display: flex;
    outline: none;
    padding: 0;
  }
}

.toggleBtn {
  color: #fff;
  display: flex;
  outline: none;

  &--open {
    opacity: 0.38;
  }
}
</style>
